import type { PaletteColor } from "@mui/material/styles/createPalette";
import type { ColorPreset } from "./index";
import { orange } from "./colors";

export const getPrimary = (preset?: ColorPreset): PaletteColor => {
  switch (preset) {
    default:
      return orange;
  }
};
